import { render, staticRenderFns } from "./TournamentDetailsHeader.vue?vue&type=template&id=1b329572&"
import script from "./TournamentDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./TournamentDetailsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports